import axios from "axios";

export const searchFilter = async (authtoken, tranId, page, perPage) => {
  return await axios.get(
    `${
      process.env.REACT_APP_API
    }/notification/search-update?tranId=${tranId}&page=${page}&perPage=${10}`,
    {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    }
  );
};
